<script>
import Coder from '@/components/Coder/Coder.vue'
import WebhookConfig from '@/views/data/modal/WebhookConfig.vue'
import STable from '@/components/Table/index'
import {
  loadAdminCurrentAmount,
  loadAlcSensorWebhookConfig, loadAlcWebhookRecord,
  sendMockAlcSensorWebhookData,
  switchEnableAlcSensorWebhookConfig
} from '@/api/data'
import PayAmount from '@/views/data/modal/PayAmount.vue'
import moment from 'moment'

export default {
  name: 'WebHook',
  components: {
    Coder,
    STable
  },
  data () {
    return {
      queryStatus: 999,
      enable: false,
      queryParams: {},
      height: document.body.clientHeight - 216,
      keyShow: false,
      config: null,
      visible: true,
      mAmount: 0,
      isCN: false,
      postData: JSON.stringify({
        event_type: 'test',
        message_id: '20241014000000000672',
        message: 'This is real data, please save it to your database.',
        signature: 'c516e08d82bffd95a4f655b35aa4c1fc',
        data: {
          record_id: 123456789,
          user_id: 999999999,
          user_name: '',
          test_device: '812000036CD2',
          test_result: 0.333,
          result_unit: 'mg/L',
          test_timestamp: 1728879963000
        }
      }, null, 4),

      columns: [{
        title: this.$t('api.field.key'),
        dataIndex: 'key',
        width: 160,
        align: 'center'
      },
        {
          title: this.$t('api.field.type'),
          dataIndex: 'type',
          width: 100
        },
        {
          title: this.$t('api.field.desc'),
          dataIndex: 'desc'
        }],
      data: [{
        key: 'event_type',
        type: 'string',
        desc: 'The current possible values are test or mock. Test indicates that the data is official user testing data, while mock indicates that the data is simulated testing data.'
      },
        {
          key: 'message_id',
          type: 'string',
          desc: 'Message ID, unique for each message.'
        },
        {
          key: 'message',
          type: 'string',
          desc: 'Message prompt text.'
        },
        {
          key: 'signature',
          type: 'string',
          desc: 'Message signature, this field is used to verify the authenticity of the message. The algorithm is MD5 (message_id+signture_key), where signture_key is the signature key generated when configuring HTTPS URLs. For example, message_id is 2024101400000000672, and signture_key is v8ANarkc2bOwiTAPlnZUG5WZve8OJDPeC1UgWrmb6iogFtQg. After splicing the two, the final value is 2024101400000000672v8ANarkc2bOwiTAPlnZUG5WZve8OJDPeC1UgWrmb6iogFtQg, followed by MD5. The final value is c516e08d82bff95a4f655b35aa4c1fc. The server needs to verify whether the value is correct to investigate malicious sending of junk data by others.'
        },
        {
          key: 'data.record_id',
          type: 'int',
          desc: 'Record ID'
        },
        {
          key: 'data.user_id',
          type: 'int',
          desc: 'User ID'
        }, {
          key: 'data.user_name',
          type: 'string',
          desc: 'User name'
        }, {
          key: 'data.test_device',
          type: 'string',
          desc: 'The serial number of the device used by the user.'
        }, {
          key: 'data.test_result',
          type: 'float',
          desc: 'User testing result.'
        }, {
          key: 'data.result_unit',
          type: 'string',
          desc: 'Measurement unit for test results. Consistent with the configuration settings.'
        }, {
          key: 'data.test_timestamp',
          type: 'long',
          desc: 'Timestamp of testing time.'
        }],
      columns2: [{
        title: 'Message ID',
        dataIndex: 'message_id',
        align: 'center',
        width: 200
      }, {
        title: 'Status',
        dataIndex: 'status',
        align: 'center',
        width: 140,
        scopedSlots: { customRender: 'status' }
      },
        {
          title: 'Message Content',
          dataIndex: 'push_content'
        },
        {
          title: 'Message Time',
          dataIndex: 'create_time',
          align: 'center',
          width: 160
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
          width: 120
        }],
      loadData: params => {
        return loadAlcWebhookRecord(Object.assign(this.queryParams, params)).then(res => {
          const data = res.result.data
          for (const item of data) {
            item.create_time = moment(item.create_time).format('YYYY-MM-DD HH:mm:ss')
            item.push_content = decodeURIComponent(item.push_content)
          }
          return res.result
        })
}
    }
  },
  created () {
    this.isCN = window.location.hostname === 'cloud.breathmeters.cn'
    this.loadCurrentAmount()
    this.loadConfig()
  },
  methods: {
    handelChangeStatus (e) {
      this.queryStatus = e
      if (e !== 999) {
        this.queryParams.status = e
      } else {
        this.queryParams.status = null
      }
      this.$refs.table.refresh(true)
    },
    handleClose () {
      this.visible = false
      this.height = document.body.clientHeight - 186
    },
    startConfig () {
      this.showModal(WebhookConfig, 'Webhook configuration', 720, 440)
    },
    editConfig () {
      this.showModal(WebhookConfig, 'Webhook configuration', 720, 440, { config: this.config })
    },
    loadConfig () {
      loadAlcSensorWebhookConfig().then(res => {
        if (res.code === 0) {
          this.config = res.data
          switch (res.data.unit_type) {
            case 1:
              this.config.unit_type_str = 'mg/L'
              break
            case 2:
              this.config.unit_type_str = '%'
              break
            case 3:
              this.config.unit_type_str = 'mg/dl'
              break
          }
          this.enable = res.data.enable_tag === 1
        }
      })
    },
    switchKeyShow () {
      this.keyShow = !this.keyShow
    },
    mock () {
      sendMockAlcSensorWebhookData().then(res => {
        this.$message.success(this.$t('user.webhook.config.mock.sended'))
      })
    },
    handleChangeEnable (e) {
      this.enable = e
      switchEnableAlcSensorWebhookConfig({ enable_tag: e ? 1 : 0 }).then(res => {

      })
    },
    charge () {
      this.showModal(PayAmount, this.$t('user.webhook.charge'), 700, 300)
    },
    loadCurrentAmount () {
      loadAdminCurrentAmount().then(res => {
         if (res.code === 0) {
           this.mAmount = res.data
         }
      })
    }
  }
}
</script>

<template>
  <div class="webhook-page">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" :tab="$t('user.webhook.tab.config')">
        <a-alert
          v-if="visible"
          class="webhook-page__alert"
          :message="$t('user.webhook.function.tip')"
          type="warning"
          show-icon
          closable
          :after-close="handleClose" />
        <div class="config-layout">
          <a-row :gutter="16">
            <a-col :lg="12">
              <div class="amount-card">
                <div class="amount-card__row">
                  <div class="amount-card__info">
                    <span class="amount-card__label">{{ $t('user.webhook.remaining.amount') }}</span>
                    <span class="amount-card__value">{{ mAmount?mAmount.toFixed(1):"0" }}</span>
                    <span class="amount-card__unit">{{ $t('user.webhook.amount.unit') }}</span>
                  </div>
                  <div v-if="!isCN">
                    <a-button type="primary" @click="charge">{{ $t('user.webhook.charge') }}</a-button>
                  </div>
                </div>
                <div class="amount-card__tip">{{ $t('user.webhook.remaining.amount.tip') }}</div>
              </div>

              <div class="config-card">
                <div v-if="config">
                  <div class="config-card__header">
                    <span class="config-card__title">{{ $t('user.webhook.config,info') }}</span>
                    <a-switch
                      v-model="enable"
                      @change="handleChangeEnable"
                      :checked-children="$t('user.webhook.config.enable')"
                      :un-checked-children="$t('user.webhook.config.disable')" />
                  </div>
                  <div class="config-card__list">
                    <div class="config-item">
                      <div class="config-item__label">{{ $t('user.webhook.config.url') }}</div>
                      <div class="config-item__value">{{ config.push_url }}</div>
                    </div>
                    <div class="config-item">
                      <div class="config-item__label">{{ $t('user.webhook.config.key') }}</div>
                      <div class="config-item__value config-item__value--key">
                        <span class="config-item__key-text">{{ keyShow ? config.signature_key : '************************************************' }}</span>
                        <a class="config-item__toggle" @click="switchKeyShow">
                          {{ keyShow ? $t('user.webhook.config.key.hide') : $t('user.webhook.config.key.show') }}
                        </a>
                      </div>
                    </div>
                    <div class="config-item">
                      <div class="config-item__label">{{ $t('user.webhook.config.unit') }}</div>
                      <div class="config-item__value">{{ config.unit_type_str }}</div>
                    </div>
                  </div>
                  <div class="config-card__warning">{{ $t('user.webhook.config.tip5') }}</div>
                  <div class="config-card__actions">
                    <a-button @click="mock">{{ $t('user.webhook.config.mock') }}</a-button>
                    <a-button type="primary" @click="editConfig">{{ $t('user.webhook.config.update') }}</a-button>
                  </div>
                </div>
                <div class="config-card__empty" v-else>
                  <div class="config-card__empty-inner">
                    <a-icon type="inbox" class="config-card__empty-icon" />
                    <div class="config-card__empty-text">{{ $t('user.webhook.config.empty') }}</div>
                    <a-button type="primary" @click="startConfig">{{ $t('user.webhook.config') }}</a-button>
                  </div>
                </div>
              </div>
            </a-col>

            <a-col :lg="12">
              <div class="doc-card scroll-2" :style="{ height: height + 'px' }">
                <p class="doc-card__para">{{ $t('user.webhook.function.tip1') }}</p>
                <p class="doc-card__para">{{ $t('user.webhook.function.tip2') }}</p>
                <p class="doc-card__para">{{ $t('user.webhook.function.tip3') }}</p>
                <div class="doc-card__code">
                  <coder :code="postData"></coder>
                </div>
                <p class="doc-card__para doc-card__para--spaced">{{ $t('user.webhook.function.tip6') }}</p>
                <p class="doc-card__para doc-card__para--spaced">{{ $t('user.webhook.interface.json.reark') }}</p>
                <a-table :columns="columns" :data-source="data" :pagination="false" size="small">
                  <a slot="name" slot-scope="text">{{ text }}</a>
                </a-table>
              </div>
            </a-col>
          </a-row>
        </div>
      </a-tab-pane>

      <a-tab-pane key="2" :tab="$t('user.webhook.tab.record')" force-render>
        <div class="record-section">
          <div class="filter-card">
            <div class="filter-card__body">
              <div class="filter-item">
                <label class="filter-item__label">Status</label>
                <a-select style="width: 140px;" v-model="queryStatus" @change="handelChangeStatus">
                  <a-select-option :value="999">All</a-select-option>
                  <a-select-option :value="0">Sending</a-select-option>
                  <a-select-option :value="1">Success</a-select-option>
                  <a-select-option :value="2">Fail</a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="table-card">
            <s-table
              :columns="columns2"
              ref="table"
              :data="loadData"
              bordered
              size="small"
              :scroll="{ x: 1100 }">
              <div slot="status" slot-scope="text, record">
                <span v-if="record.status == 0" class="record-status record-status--sending">
                  <span class="record-status__dot"></span>Sending
                </span>
                <span v-if="record.status == 1" class="record-status record-status--success">
                  <span class="record-status__dot"></span>Success
                </span>
                <span v-if="record.status == 2" class="record-status record-status--fail">
                  <span class="record-status__dot"></span>Fail
                </span>
              </div>
              <div slot="action" slot-scope="text, record">
                <a v-if="record.status == 2" class="action-retry">Retry</a>
                <span v-else class="cell-muted">-</span>
              </div>
            </s-table>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<style scoped lang="less">
@primary: #52C41A;
@border-color: #e8e8e8;
@text-primary: rgba(0, 0, 0, 0.85);
@text-secondary: rgba(0, 0, 0, 0.45);
@radius: 6px;
@shadow-card: 0 1px 2px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
@transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);

.webhook-page {
  &__alert {
    margin-bottom: 12px;
    border-radius: @radius;
  }
}

.config-layout {
  margin-top: 4px;
}

/* ── Amount card ── */
.amount-card {
  background: #fff;
  border-radius: @radius;
  box-shadow: @shadow-card;
  padding: 16px 20px;

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__info {
    display: flex;
    align-items: baseline;
    gap: 8px;
    flex: 1;
  }

  &__label {
    font-size: 13px;
    color: @text-secondary;
  }

  &__value {
    font-size: 24px;
    font-weight: 700;
    color: @primary;
    line-height: 1;
  }

  &__unit {
    font-size: 13px;
    color: @text-secondary;
  }

  &__tip {
    margin-top: 8px;
    font-size: 12px;
    color: @text-secondary;
    line-height: 1.5;
  }
}

/* ── Config card ── */
.config-card {
  background: #fff;
  border-radius: @radius;
  box-shadow: @shadow-card;
  padding: 16px 20px;
  margin-top: 16px;
  min-height: 380px;
  position: relative;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  &__title {
    font-size: 15px;
    font-weight: 600;
    color: @text-primary;
  }

  &__list {
    margin-top: 8px;
  }

  &__warning {
    padding: 12px 0;
    font-size: 13px;
    color: #d48806;
    line-height: 1.5;
  }

  &__actions {
    position: absolute;
    bottom: 16px;
    left: 0;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    gap: 12px;
  }

  &__empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 340px;
  }

  &__empty-inner {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  &__empty-icon {
    font-size: 48px;
    color: rgba(0, 0, 0, 0.15);
  }

  &__empty-text {
    font-size: 14px;
    color: @text-secondary;
  }
}

/* ── Config items ── */
.config-item {
  padding: 12px 0;
  border-top: 1px solid @border-color;

  &:last-child {
    border-bottom: 1px solid @border-color;
  }

  &__label {
    font-size: 13px;
    font-weight: 600;
    color: @text-primary;
    margin-bottom: 4px;
  }

  &__value {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 1.5;
    word-break: break-all;

    &--key {
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }

  &__key-text {
    flex: 1;
    font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
    font-size: 12px;
    color: @text-secondary;
  }

  &__toggle {
    font-size: 13px;
    color: @primary;
    white-space: nowrap;
    transition: color @transition;

    &:hover {
      color: darken(@primary, 10%);
    }
  }
}

/* ── Doc card ── */
.doc-card {
  background: #fff;
  border-radius: @radius;
  box-shadow: @shadow-card;
  padding: 16px 20px;
  overflow: auto;

  &__para {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 1.6;
    margin: 0 0 8px;

    &--spaced {
      margin-top: 16px;
    }
  }

  &__code {
    margin: 12px 0;
  }
}

/* ── Record section ── */
.record-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.filter-card {
  background: #fff;
  border-radius: @radius;
  box-shadow: @shadow-card;
  overflow: hidden;

  &__body {
    padding: 12px 20px 16px;
  }
}

.filter-item {
  display: flex;
  align-items: center;

  &__label {
    flex-shrink: 0;
    font-size: 13px;
    color: @text-secondary;
    margin-right: 10px;
    white-space: nowrap;
  }
}

.table-card {
  background: #fff;
  border-radius: @radius;
  box-shadow: @shadow-card;
  padding: 16px 20px;
}

.cell-muted {
  color: @text-secondary;
  font-size: 13px;
}

/* ── Record status ── */
.record-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 10px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.6;

  &__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &--sending {
    background: #e6f7ff;
    color: #1890ff;

    .record-status__dot {
      background: #1890ff;
    }
  }

  &--success {
    background: #f6ffed;
    color: #389e0d;

    .record-status__dot {
      background: @primary;
    }
  }

  &--fail {
    background: #fff1f0;
    color: #cf1322;

    .record-status__dot {
      background: #ff4d4f;
    }
  }
}

.action-retry {
  font-size: 13px;
  color: @primary;
  transition: color @transition;

  &:hover {
    color: darken(@primary, 10%);
  }
}

@media (max-width: 768px) {
  .filter-card__body {
    padding: 12px;
  }

  .table-card {
    padding: 12px;
  }
}
</style>
